import styles from './progress-bar.module.scss';

export interface ProgressBarSkeletonProps {
	className?: string;
}

export function ProgressBarSkeleton({ className }: ProgressBarSkeletonProps): JSX.Element {
	const rootClassName = [styles.track, styles.skeleton, className].filter(Boolean).join(' ');
	return (
		<div className={rootClassName} data-test-id="progress-bar-skeleton">
			<div className={`${styles.segment} ${styles.skeletonSegment}`} />
		</div>
	);
}

export default ProgressBarSkeleton;
